<template>
    <div>
        <el-input 
            v-if="mode == 'edit'"
            :placeholder="prop.defaultValue" 
            v-model="currentValue">
        </el-input>
        <p v-else> {{currentValue}} </p>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'

    export default {
        mixins: [CfMixin],

        data(){
            return {
                localValue : this.value,
                currentValue: ''
            }
        },

        created(){
            if(!this.localValue){
                this.localValue = JSON.parse(JSON.stringify(this.templateData))
                this.currentValue = this.prop.defaultValue
            } else{
                this.currentValue = this.value.stringValue
            }
        },

        watch: {
            currentValue(newValue) {
                this.$emit('input', {...this.localValue, ['stringValue'] : newValue})
            },
            value : {
                handler: function (newValue) { 
                    this.localValue = newValue
                    this.currentValue = newValue.stringValue
                },
                deep: true
            }
        }
    }
</script>
